import Helpers from '@Apis/helpers';

export const allEntityNames = [
  { entityName: 'PRODUCTS', permissionEntityName: 'PRODUCT' },
  { entityName: 'VENDORS', permissionEntityName: 'VENDORS' },
  { entityName: 'CUSTOMERS', permissionEntityName: 'CUSTOMER' },
  { entityName: 'PURCHASE_ORDERS', permissionEntityName: 'PURCHASE_ORDER' },
  { entityName: 'SALES_ORDER', permissionEntityName: 'SALES_ORDER' },
  { entityName: 'GOOD_RECEIVING_NOTES', permissionEntityName: 'GOOD_RECEIVING' },
  { entityName: 'INVOICE', permissionEntityName: 'INVOICE' },
  { entityName: 'MANUFACTURING_ORDER', permissionEntityName: 'MO' },
];

const additionalStatusStyle = {
  color: 'white',
  fontWeight: 600,
  padding: '3px 7px',
  borderRadius: '3px',
  boxSizing: 'border-box',
  width: 'fit-content',
  fontSize: '11px',
};

const additionalStatusStyleWithoutBG = {
  fontWeight: 600,
  boxSizing: 'border-box',
  width: 'fit-content',
  fontSize: '12px',
};

export const getStatusColor = (status) => {
  switch (status) {
  case 'DRAFT': return { style: { backgroundColor: 'rgb(136,180,248)', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'PENDING': return { style: { backgroundColor: '#dcaa06', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'VOID': return { style: { backgroundColor: '#939393', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'ISSUED': return { style: { backgroundColor: '#22C55EFF', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'SENT_FOR_APPROVAL': return { style: { backgroundColor: '#1c7be1', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'CANCELLED': return { style: { backgroundColor: '#ff0000', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'APPROVED': return { style: { backgroundColor: '#22C55EFF', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'REJECTED': return { style: { backgroundColor: '#ff0000', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'PAID': return { style: { color: '#22C55EFF', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'PAYMENT_PROCESSING': return { style: { color: '#2daef7', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'PAYMENT_FAILED': return { style: { color: '#ff0000', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'PAYMENT_STARTED': return { style: { color: '#22C55EFF', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'PAYMENT_SUCCESS': return { style: { color: '#22C55EFF', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'NOT_RECEIVED': return { style: { color: '#b0b0b0', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'PARTIALLY_RECEIVED': return { style: { color: '#3e77cc', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'RECEIVED_MORE': return { style: { color: '#22C55EFF', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'PARTIALLY_PAID': return { style: { color: '#3e77cc', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'PAID_MORE': return { style: { color: '#22C55EFF', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'RECEIVED': return { style: { color: '#22C55EFF', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'BILLED': return { style: { color: '#22C55EFF', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'NOT_PAID': return { style: { color: '#b0b0b0', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  case 'SENT_FOR_REVISION': return { style: { backgroundColor: '#f68d16', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'COMPLETED': return { style: { backgroundColor: '#22C55EFF', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'CONFIRMED': return { style: { backgroundColor: '#22C55EFF', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'DELIVERED': return { style: { backgroundColor: '#22C55EFF', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'PARTIALLY_FULFILLED': return { style: { backgroundColor: '#3e77cc', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'FULFILLED': return { style: { backgroundColor: '#22C55EFF', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'PLANNED': return { style: { backgroundColor: '#22C55EFF', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'IN_PROGRESS': return { style: { backgroundColor: '#2daef7', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'PENDING_FOR_QC': return { style: { backgroundColor: '#06b5dc', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'DONE': return { style: { backgroundColor: '#22C55EFF', ...additionalStatusStyle }, className: 'additional_status_style' };
  case 'CLOSED': return { style: { backgroundColor: '#22C55EFF', ...additionalStatusStyle }, className: 'additional_status_style' };
  default: return { style: { color: '#dcaa06', ...additionalStatusStyleWithoutBG }, className: 'additional_status_style_without_bg' };
  }
};

export const entityNameBgColors = (entityName) => {
  switch (entityName) {
  case 'PRODUCTS':
    return 'magenta';

  case 'VENDORS':
    return 'cyan';

  case 'CUSTOMERS':
    return 'orange';

  case 'PURCHASE_ORDERS':
    return 'geekblue';

  case 'SALES_ORDER':
    return 'volcano';

  case 'GOOD_RECEIVING_NOTES':
    return 'green';

  case 'INVOICE':
    return 'purple';

  case 'MANUFACTURING_ORDER':
    return 'lime';

  default:
    return 'blue';
  }
};

export const filterDataBasedOnPermission = ({ dataToBeFiltered, entityNames, user }) => {
  if (entityNames.length === 0) {
    return dataToBeFiltered;
  }

  const currentEntityName = entityNames[0];

  const hasPermission = Helpers.getPermission(
    Helpers.permissionEntities[currentEntityName.permissionEntityName],
    Helpers.permissionTypes.READ,
    user,
  );

  const filteredData = hasPermission
    ? dataToBeFiltered
    : dataToBeFiltered.filter((item) => (item?.entity_name || item?.value) !== currentEntityName.entityName);

  return filterDataBasedOnPermission({ dataToBeFiltered: filteredData, entityNames: entityNames.slice(1), user });
};

export const getAvatarBgColor = (entityName) => {
  switch (entityName) {
  case 'PRODUCTS':
    return { backgroundColor: '#c41d7f26', color: '#c41d7f80' };

  case 'VENDORS':
    return { backgroundColor: '#08979c26', color: '#08979c80' };

  case 'CUSTOMERS':
    return { backgroundColor: '#d46b0826', color: '#d46b0880' };

  case 'PURCHASE_ORDERS':
    return { backgroundColor: '#2F54EB26', color: '#2F54EB80' };

  case 'SALES_ORDER':
    return { backgroundColor: '#FA541C26', color: '#FA541C80' };

  case 'GOOD_RECEIVING_NOTES':
    return { backgroundColor: '#00800026', color: '#00800080' };

  case 'INVOICE':
    return { backgroundColor: '#80008026', color: '#80008080' };

  case 'MANUFACTURING_ORDER':
    return { backgroundColor: '#7cb30526', color: '#7cb30580' };

  default:
    return { backgroundColor: '#0000FF26', color: '#0000FF80' };
  }
};

export const TruncatedText = ({ text, maxLength }) => {
  if (text.length > maxLength) {
    return `${text.substring(0, maxLength)}...`;
  }
  return text;
};
